<script setup lang="ts">
import { IconMail } from '@tabler/icons-vue';

withDefaults(defineProps<{ confirming?: boolean; detail?: string; email: string }>(), {
    detail: 'for a secure link to continue.',
});
defineEmits<{ back: [] }>();
</script>

<template>
    <div class="placeholder gap-md m-0">
        <IconMail class="placeholder__icon" />
        <h2 class="color-text">Check Your Email</h2>
        <p class="color-text">
            Check <strong>{{ email }}</strong> {{ detail }}
        </p>
        <p class="text-sm">If it doesn’t arrive within a few minutes, check your spam folder.</p>
        <button class="btn btn--transparent color-primary full-width" @click="$emit('back')">
            {{ confirming ? 'Use Another Method' : 'Use Another Email' }}
        </button>
    </div>
</template>
